import React from 'react';
import {Header} from './components/header';
import {CompanyProfile} from './components/companyProfile';
import Footer from './components/footer';
import style from './index.module.css';


function App() {
  return (
    <div className={style.App}>
      <Header/>
      <CompanyProfile />
      <Footer />
    </div>
  );
}

export default App;
